import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const CuetVistas = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector(".vistasHeader");
      if (window.scrollY > 50) {
        header?.classList.add("smallHeader");
      } else {
        header?.classList.remove("smallHeader");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  var settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    autoplaySpeed: 2000,
    autoplay: true,
    slidesToScroll: 1,
  };
  return (
    <>
      <div className="vistasHeader">
        <div className="vistas-logo">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas-logo.png"
            className="img-fluid"
            alt="Lotus Valley School, Gurgaon"
          />
        </div>
        <div className="hamburger" onClick={toggleMenu}>
          {menuOpen ? "✖" : "☰"}
        </div>
        <ul className={`vistas-menu ${menuOpen ? "open" : ""}`}>
          <li>
            <Link to="/vistas">Introduction</Link>
          </li>
          <li>
            <Link to="/counselling-session-vistas">Counselling Session</Link>
          </li>
          <li>
            <Link to="/upcomingevt-vistas">Upcoming Events</Link>
          </li>
          {/* <li>
            <Link to="/update-vistas">Updates</Link>
          </li>
          <li>
            <Link to="/spotlight-vistas">Spotlight</Link>
          </li> */}
          <li>
            <Link to="/connect-vistas">Connect with Us</Link>
          </li>
        </ul>
      </div>
      <div className="slider-vistas">
        <Slider {...settings}>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas1.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas2.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas3.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas4.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas5.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas6.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas7.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
          <div>
            <img
              src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/vistas8.jpg"
              alt="Lotus Valley Gurgaon"
              className="img-fluid"
            />{" "}
          </div>
        </Slider>
      </div>
      <div className="padding-wid vistas_p">
        <div class="container">
          <div class="text-center d-block">
            <h3 class="mx-auto text-black mb-4 font-play">
              THE COMMON UNIVERSITY ENTRANCE TEST (CUET)
            </h3>
          </div>
          <div class="table">
            <table border="1" cellspacing="0" cellpadding="0" class="w-100">
              <tbody>
                <tr>
                  <td colspan="2">
                    <strong>The Common University Entrance Test (CUET)</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Particulars </strong>
                  </td>
                  <td>
                    <strong>Details </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Name of the Examination<strong> </strong>
                  </td>
                  <td>The Common University Entrance Test (CUET (UG)</td>
                </tr>
                <tr>
                  <td>
                    Conducting Body<strong> </strong>
                  </td>
                  <td>
                    National Testing Agency (NTA)<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Level of Examination<strong> </strong>
                  </td>
                  <td>
                    Undergraduate Exam at the National Level<strong> </strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    Exam Frequency<strong> </strong>
                  </td>
                  <td>Once a year</td>
                </tr>
                <tr>
                  <td>
                    Exam Mode<strong> </strong>
                  </td>
                  <td>Online (Computer-Based Mode)</td>
                </tr>
                <tr>
                  <td>
                    Courses Offered via Entrance Exam<strong> </strong>
                  </td>
                  <td>
                    UG and PG courses of state, central, private and deemed
                    universities
                  </td>
                </tr>
                <tr>
                  <td>Mode of Application</td>
                  <td>Online and pen paper mode</td>
                </tr>
                <tr>
                  <td>Exam Duration</td>
                  <td>
                    45 minutes&nbsp;for each Language
                    <br />
                    45 minutes&nbsp;for each Domain Subject
                    <br />
                    60 minutes for General Test
                  </td>
                </tr>
                <tr>
                  <td>Papers and Total Marks</td>
                  <td>
                    Section IA (Language)/IB- 40&nbsp;questions to be attempted
                    out of&nbsp;50&nbsp;in each language
                    <br />
                    Section II (Domain Subject)- 35/40&nbsp;Questions to be
                    attempted out of&nbsp;45/50
                    <br />
                    Section III (General Test)- 50&nbsp;Questions to be
                    attempted out of&nbsp;60
                    <br />
                    The total marks of the CUET&nbsp;exam&nbsp;vary&nbsp;based
                    on the subjects chosen
                  </td>
                </tr>
                <tr>
                  <td>Marking Scheme</td>
                  <td>
                    +5 for each correct answer
                    <br />
                    -1 for each incorrect answer
                    <br />
                    Unanswered/Marked for Review&nbsp;will receive no&nbsp;mark
                    (0)
                  </td>
                </tr>
                <tr>
                  <td>Colleges Accepting Exam Score</td>
                  <td>Central, State, Private and Deemed Universities</td>
                </tr>
                <tr>
                  <td>Official Website</td>
                  <td>cuet.samarth.ac.in</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="copyright-vistas">
        © 2024 All rights reserved with Lotus Valley School, Gurgaon
      </div>
    </>
  );
};
export default CuetVistas;

